export type SectionQuestion = { id: number; lessonName: string };
export function subjectGroups<T extends SectionQuestion>(questions: T[]) {
  const groups = new Map<string, T[]>();
  for (const question of questions) {
    if (!question.lessonName.trim()) continue;
    const group = groups.get(question.lessonName) ?? [];
    if (!group.some(q => q.id === question.id)) group.push(question);
    groups.set(question.lessonName, group);
  }
  return [...groups].sort(([a], [b]) => {
    const priority = (s: string) => s === "Türkçe" ? 0 : s === "Matematik" ? 1 : 2;
    return priority(a) - priority(b) || a.localeCompare(b, "tr");
  });
}
export function assembleSections<T extends SectionQuestion>(questions: T[], counts: Record<string, number>, seed: number): T[] {
  return subjectGroups(questions).flatMap(([subject, rows]) => {
    const count = Math.max(0, Math.min(rows.length, Math.floor(counts[subject] || 0), 100));
    const shuffled = [...rows];
    let value = seed >>> 0;
    for (let i = shuffled.length - 1; i > 0; i--) {
      value = (Math.imul(value, 1664525) + 1013904223) >>> 0;
      const j = value % (i + 1);
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled.slice(0, count);
  });
}
